// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 850px) {
    .scl--jcbs-sub-app-bo-con-st{
        padding-left: var(--global-tablet-padding-left);
        padding-right: var(--global-tablet-padding-left);
        flex-direction: column;
        gap: 45px;
    }

    .scl--jsabcs-bo-st{
        width: 100%;
    }

    

    .scl--jbs-car-ti-bo-dis-st{
        width: 100%;
        height: auto;
        min-height: 600px;
        gap: 20px;
        padding-bottom: 200px;
    }

    .scl--jsbcs-bo-inp-co-st{
        width: 100%;
    }

    .scl--fi-bo-up-co-st{
        flex-direction: column;
        gap: 50px;
    }

    .scl--fgaus-ro-bt-st{
        width: 400px;
        height: 57px;
        border-radius: 30px;
    }

    .scl--fgaus-ro-bt-st .scl--web-component-round-button-text{
        font-size: 24px;
    }

    .scl--fbucs-su-bt-cd-st{
        width: 100%;
        height: 57px;
        border-radius: 30px;
    }

    .scl--fbucs-su-bt-cd-st .scl--web-component-round-button-text{
        font-size: 24px;
    }

    .scl--jctbds-btn-st{
        width: 291px;
        height: 51px;
        border-radius: 30px;
    }

    .scl--jbs-car-ti-bo-dis-st p, .scl--jbs-car-ti-bo-dis-st span{
        font-size: 28px;
    }

    .scl--jbs-car-ti-bo-dis-st span{
        margin-top: auto;
    }

    .scl--jctbds-btn-st .scl--web-component-round-button-text{
        font-size: 28px;
        margin: 0px;
    }

    .scl--jvbcs-des-bo-st{
        font-size: 20px;
    }

    .scl--jbics-val-bo-ch-st{
        position: relative;
        text-indent: 35px;
    }

    .scl--jbics-val-bo-ch-st .scl--web-component-checkbox-container{
        position: absolute;
    }
}`, "",{"version":3,"sources":["webpack://./src/page-module/page-services/job-detail/css/jobSubmittedSt.css"],"names":[],"mappings":"AAAA;IACI;QACI,+CAA+C;QAC/C,gDAAgD;QAChD,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,WAAW;IACf;;;;IAIA;QACI,WAAW;QACX,YAAY;QACZ,iBAAiB;QACjB,SAAS;QACT,qBAAqB;IACzB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,YAAY;QACZ,YAAY;QACZ,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,YAAY;QACZ,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;IACtB;AACJ","sourcesContent":["@media (max-width: 850px) {\n    .scl--jcbs-sub-app-bo-con-st{\n        padding-left: var(--global-tablet-padding-left);\n        padding-right: var(--global-tablet-padding-left);\n        flex-direction: column;\n        gap: 45px;\n    }\n\n    .scl--jsabcs-bo-st{\n        width: 100%;\n    }\n\n    \n\n    .scl--jbs-car-ti-bo-dis-st{\n        width: 100%;\n        height: auto;\n        min-height: 600px;\n        gap: 20px;\n        padding-bottom: 200px;\n    }\n\n    .scl--jsbcs-bo-inp-co-st{\n        width: 100%;\n    }\n\n    .scl--fi-bo-up-co-st{\n        flex-direction: column;\n        gap: 50px;\n    }\n\n    .scl--fgaus-ro-bt-st{\n        width: 400px;\n        height: 57px;\n        border-radius: 30px;\n    }\n\n    .scl--fgaus-ro-bt-st .scl--web-component-round-button-text{\n        font-size: 24px;\n    }\n\n    .scl--fbucs-su-bt-cd-st{\n        width: 100%;\n        height: 57px;\n        border-radius: 30px;\n    }\n\n    .scl--fbucs-su-bt-cd-st .scl--web-component-round-button-text{\n        font-size: 24px;\n    }\n\n    .scl--jctbds-btn-st{\n        width: 291px;\n        height: 51px;\n        border-radius: 30px;\n    }\n\n    .scl--jbs-car-ti-bo-dis-st p, .scl--jbs-car-ti-bo-dis-st span{\n        font-size: 28px;\n    }\n\n    .scl--jbs-car-ti-bo-dis-st span{\n        margin-top: auto;\n    }\n\n    .scl--jctbds-btn-st .scl--web-component-round-button-text{\n        font-size: 28px;\n        margin: 0px;\n    }\n\n    .scl--jvbcs-des-bo-st{\n        font-size: 20px;\n    }\n\n    .scl--jbics-val-bo-ch-st{\n        position: relative;\n        text-indent: 35px;\n    }\n\n    .scl--jbics-val-bo-ch-st .scl--web-component-checkbox-container{\n        position: absolute;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
